// CSS
import "./InfoBox.css";

/** 
 * This component renders an information box with the following styles/components:
 * - default: grey section containing text
 * - success: green section containing text
 * - error: grey section containing red text
 * - close: 'x' used to close the information box
 * 
 * @param   {string} children The text displayed in the information box.
 * @param   {string} boxStyle The style to render the information box in.
 * @param   {boolean} isVisible Whether the indicator should be visible.
 * @param   {(e: React.MouseEvent) => void} onClose The function to call when the indicator is closed.
 * @returns {ReactElement} A React element that renders an information box. 
 */
export default function InfoBox({children, boxStyle, isVisible, onClose}) {
    if (!isVisible) return;

    return (
        <div>
            <div className={`info-box ${boxStyle}`}>
                <p className="info-box-text">{children}</p>
                <button className="close" onClick={onClose}>x</button>
            </div>
        </div>
    )
}